import axiosService from "./axios.service";

export interface AdminHackathonSummary {
    _id: string;
    slug: string;
    name: string;
    archived: boolean;
    closed: boolean;
    hasInviteCode: boolean;
    domain: string;
    endDate: string | null;
    plan: 'free' | 'pro';
    // how a Pro event got Pro: paid for, granted by a Persera admin, or neither on record
    planSource: 'paid' | 'granted' | 'other' | null;
    participantCount: number;
    ideaCount: number;
    createdAt: string;
    createdBy: {
        username: string;
        email: string;
    } | null;
}

export interface AdminHackathonsResponse {
    hackathons: AdminHackathonSummary[];
    total: number;
}

export const getAdminHackathons = async (page: number, search?: string): Promise<AdminHackathonsResponse> => {
    const { data } = await axiosService.get(`/api/admin/hackathons`, {
        params: { page, search: search || undefined }
    });
    return data;
};

/** Turns Pro on or off for a hackathon without a payment (Persera admins). An event someone paid for can't be made Free. */
export const setHackathonPlan = async (id: string, plan: 'free' | 'pro'): Promise<AdminHackathonSummary> => {
    const { data } = await axiosService.post(`/api/admin/hackathons/${id}/plan`, { plan });
    return data;
};

export const archiveHackathon = async (id: string): Promise<AdminHackathonSummary> => {
    const { data } = await axiosService.post(`/api/admin/hackathons/${id}/archive`);
    return data;
};

export const unarchiveHackathon = async (id: string): Promise<AdminHackathonSummary> => {
    const { data } = await axiosService.post(`/api/admin/hackathons/${id}/unarchive`);
    return data;
};

export const deleteHackathon = async (id: string): Promise<{ success: boolean }> => {
    const { data } = await axiosService.delete(`/api/admin/hackathons/${id}`);
    return data;
};
